import { useQuery } from '@tanstack/react-query';
import { favoriteMarketService } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';

export const useFavoriteMarketsWithNewGoods = () => {
  return useQuery({
    queryKey: queryKey.favoriteMarketsWithNewGoods(),
    queryFn: () => favoriteMarketService.getWithNewGoods(),
  });
};
